var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"levelBox"},[_c('div',{staticClass:"title"},[_vm._v("赛事级别")]),_c('div',{staticClass:"fl",style:("width: 100%; height: 370px;"),attrs:{"id":"level"}})])}
var staticRenderFns = []

export { render, staticRenderFns }